import { render, staticRenderFns } from "./_logo.vue?vue&type=template&id=deb52e8e&scoped=true&"
import script from "./_logo.vue?vue&type=script&lang=js&"
export * from "./_logo.vue?vue&type=script&lang=js&"
import style0 from "./_logo.vue?vue&type=style&index=0&id=deb52e8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb52e8e",
  null
  
)

export default component.exports